export default __webpack_public_path__ + "static/fits-1ebc019aa123442c7e7395a81a1394c1.png";